"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotecardMasteryPrivateStatesForPublic = exports.NotecardMasteryStateDeprecatedToNotecardMasteryStatePrivate = exports.NotecardMasteryStateDeprecated = exports.MINIMUM_NOTECARD_SET_SIZE = exports.MasteryWaitDurationHours = exports.NotecardNavigationDirection = exports.NotecardPriority = exports.twoWayNotecardMasteryPrivatePublicMap = exports.NotecardMasteryPrivateToPublicMap = exports.NotecardGradingResult = exports.PUBLIC_MASTERED_STATES = exports.PRIVATE_MASTERED_STATES = exports.PRIVATE_MASTERED_STATE_MINIMUM = exports.isMasteredPublic = exports.isMasteredPrivate = exports.getPenaltyForIncorrectAnswerAtState = exports.PUBLIC_MASTERED_STATE_MINIMUM = exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE = exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PUBLIC = exports.NotecardMasteryStatePublic = exports.NotecardMasteryStatePrivate = void 0;
const twoWayMap_1 = require("../utils/twoWayMap");
const convertRecordToMap_1 = require("../utils/convertRecordToMap");
var NotecardMasteryStatePrivate;
(function (NotecardMasteryStatePrivate) {
    NotecardMasteryStatePrivate["new"] = "new";
    NotecardMasteryStatePrivate["apprentice1"] = "apprentice1";
    NotecardMasteryStatePrivate["apprentice2"] = "apprentice2";
    NotecardMasteryStatePrivate["apprentice3"] = "apprentice3";
    NotecardMasteryStatePrivate["apprentice4"] = "apprentice4";
    NotecardMasteryStatePrivate["guru1"] = "guru1";
    NotecardMasteryStatePrivate["guru2"] = "guru2";
    NotecardMasteryStatePrivate["master"] = "master";
    NotecardMasteryStatePrivate["enlightened"] = "enlightened";
    NotecardMasteryStatePrivate["burned"] = "burned";
})(NotecardMasteryStatePrivate || (exports.NotecardMasteryStatePrivate = NotecardMasteryStatePrivate = {}));
var NotecardMasteryStatePublic;
(function (NotecardMasteryStatePublic) {
    NotecardMasteryStatePublic["new"] = "new";
    NotecardMasteryStatePublic["apprentice"] = "apprentice";
    NotecardMasteryStatePublic["guru"] = "guru";
    NotecardMasteryStatePublic["master"] = "master";
    NotecardMasteryStatePublic["enlightened"] = "enlightened";
    NotecardMasteryStatePublic["burned"] = "burned";
})(NotecardMasteryStatePublic || (exports.NotecardMasteryStatePublic = NotecardMasteryStatePublic = {}));
exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PUBLIC = (0, twoWayMap_1.buildReadOnlyTwoWayIndexMapForEnum)(NotecardMasteryStatePublic);
exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE = (0, twoWayMap_1.buildReadOnlyTwoWayIndexMapForEnum)(NotecardMasteryStatePrivate);
exports.PUBLIC_MASTERED_STATE_MINIMUM = NotecardMasteryStatePublic.master;
const getPenaltyForIncorrectAnswerAtState = (privateState) => {
    return exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE.getForward(privateState) >=
        exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE.getForward(NotecardMasteryStatePrivate.guru1)
        ? 2
        : 1;
};
exports.getPenaltyForIncorrectAnswerAtState = getPenaltyForIncorrectAnswerAtState;
const isMasteredPrivate = (privateState) => exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE.getForward(privateState) >=
    exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PRIVATE.getForward(exports.PRIVATE_MASTERED_STATE_MINIMUM);
exports.isMasteredPrivate = isMasteredPrivate;
const isMasteredPublic = (publicState) => exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PUBLIC.getForward(publicState) >=
    exports.NOTECARD_MASTERY_STATE_TWO_WAY_MAP_PUBLIC.getForward(exports.PUBLIC_MASTERED_STATE_MINIMUM);
exports.isMasteredPublic = isMasteredPublic;
exports.PRIVATE_MASTERED_STATE_MINIMUM = NotecardMasteryStatePrivate.master;
exports.PRIVATE_MASTERED_STATES = Object.values(NotecardMasteryStatePrivate).filter((state) => (0, exports.isMasteredPrivate)(state));
exports.PUBLIC_MASTERED_STATES = Object.values(NotecardMasteryStatePublic).filter((state) => (0, exports.isMasteredPublic)(state));
var NotecardGradingResult;
(function (NotecardGradingResult) {
    NotecardGradingResult["fullCredit"] = "fullCredit";
    NotecardGradingResult["partialCredit"] = "partialCredit";
    NotecardGradingResult["noCredit"] = "noCredit";
})(NotecardGradingResult || (exports.NotecardGradingResult = NotecardGradingResult = {}));
exports.NotecardMasteryPrivateToPublicMap = {
    [NotecardMasteryStatePrivate.new]: NotecardMasteryStatePublic.new,
    [NotecardMasteryStatePrivate.apprentice1]: NotecardMasteryStatePublic.apprentice,
    [NotecardMasteryStatePrivate.apprentice2]: NotecardMasteryStatePublic.apprentice,
    [NotecardMasteryStatePrivate.apprentice3]: NotecardMasteryStatePublic.apprentice,
    [NotecardMasteryStatePrivate.apprentice4]: NotecardMasteryStatePublic.apprentice,
    [NotecardMasteryStatePrivate.guru1]: NotecardMasteryStatePublic.guru,
    [NotecardMasteryStatePrivate.guru2]: NotecardMasteryStatePublic.guru,
    [NotecardMasteryStatePrivate.master]: NotecardMasteryStatePublic.master,
    [NotecardMasteryStatePrivate.enlightened]: NotecardMasteryStatePublic.enlightened,
    [NotecardMasteryStatePrivate.burned]: NotecardMasteryStatePublic.burned,
};
const buildTwoWayNotecardMasteryPrivatePublicMap = () => {
    const publicPrivateMap = (0, convertRecordToMap_1.recordToMap)(exports.NotecardMasteryPrivateToPublicMap);
    return new twoWayMap_1.ReadOnlyTwoWayMap(publicPrivateMap);
};
exports.twoWayNotecardMasteryPrivatePublicMap = buildTwoWayNotecardMasteryPrivatePublicMap();
var NotecardPriority;
(function (NotecardPriority) {
    NotecardPriority["high"] = "high";
    NotecardPriority["medium"] = "medium";
    NotecardPriority["low"] = "low";
})(NotecardPriority || (exports.NotecardPriority = NotecardPriority = {}));
var NotecardNavigationDirection;
(function (NotecardNavigationDirection) {
    NotecardNavigationDirection["next"] = "next";
    NotecardNavigationDirection["previous"] = "previous";
})(NotecardNavigationDirection || (exports.NotecardNavigationDirection = NotecardNavigationDirection = {}));
exports.MasteryWaitDurationHours = {
    [NotecardMasteryStatePrivate.new]: 0,
    [NotecardMasteryStatePrivate.apprentice1]: 4,
    [NotecardMasteryStatePrivate.apprentice2]: 8,
    [NotecardMasteryStatePrivate.apprentice3]: 24,
    [NotecardMasteryStatePrivate.apprentice4]: 24 * 2,
    [NotecardMasteryStatePrivate.guru1]: 24 * 7,
    [NotecardMasteryStatePrivate.guru2]: 24 * 7 * 2,
    [NotecardMasteryStatePrivate.master]: 24 * 7 * 4,
    [NotecardMasteryStatePrivate.enlightened]: 24 * 7 * 4 * 4,
    [NotecardMasteryStatePrivate.burned]: 999999999,
};
exports.MINIMUM_NOTECARD_SET_SIZE = 3;
var NotecardMasteryStateDeprecated;
(function (NotecardMasteryStateDeprecated) {
    NotecardMasteryStateDeprecated["new"] = "new";
    NotecardMasteryStateDeprecated["learning"] = "learning";
    NotecardMasteryStateDeprecated["nearlyMastered"] = "nearly mastered";
    NotecardMasteryStateDeprecated["mastered"] = "mastered";
})(NotecardMasteryStateDeprecated || (exports.NotecardMasteryStateDeprecated = NotecardMasteryStateDeprecated = {}));
exports.NotecardMasteryStateDeprecatedToNotecardMasteryStatePrivate = {
    [NotecardMasteryStateDeprecated.new]: NotecardMasteryStatePrivate.new,
    [NotecardMasteryStateDeprecated.learning]: NotecardMasteryStatePrivate.apprentice2,
    [NotecardMasteryStateDeprecated.nearlyMastered]: NotecardMasteryStatePrivate.guru1,
    [NotecardMasteryStateDeprecated.mastered]: NotecardMasteryStatePrivate.master,
};
const getNotecardMasteryPrivateStatesForPublic = (publicState) => {
    const privateStates = [];
    Object.entries(exports.NotecardMasteryPrivateToPublicMap).forEach(([_privateState, _publicState]) => {
        if (_publicState === publicState) {
            privateStates.push(_privateState);
        }
    });
    return privateStates;
};
exports.getNotecardMasteryPrivateStatesForPublic = getNotecardMasteryPrivateStatesForPublic;
//# sourceMappingURL=consts.js.map